export default "__VITE_ASSET__dd4d3121__"